import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ArchiveEnvironmentDialogComponent, ArchiveEnvironmentDialogData, ArchiveEnvironmentDialogResult } from './archive-environment-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ArchiveEnvironmentDialogService {
  constructor(private matDialog: MatDialog) {}

  public open(data: ArchiveEnvironmentDialogData): Promise<ArchiveEnvironmentDialogResult> {
    return this.matDialog.open<ArchiveEnvironmentDialogComponent, ArchiveEnvironmentDialogData, ArchiveEnvironmentDialogResult>(ArchiveEnvironmentDialogComponent, {
      autoFocus: false,
      data: data
    }).afterClosed()
      .toPromise();
  }
}
